(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  const initCollectionDescriptionToggle = (section) => {
    if (!section) return;

    const wrappers = section.querySelectorAll('[data-collection-description]');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const description = wrapper.querySelector('.collection__description');
      const toggle = wrapper.querySelector('[data-collection-description-toggle]');
      if (!description || !toggle) return;

      const mobileBreakpoint = window.matchMedia('(max-width: 798px)');
      const computedStyles = window.getComputedStyle(description);
      const lineHeight = Number.parseFloat(computedStyles.lineHeight);
      const fontSize = Number.parseFloat(computedStyles.fontSize) || 16;
      const resolvedLineHeight = Number.isFinite(lineHeight) ? lineHeight : fontSize * 1.5;
      const collapsedHeight = resolvedLineHeight * 2;
      description.style.setProperty('--collection-description-collapsed-height', `${collapsedHeight}px`);

      const applyState = () => {
        if (!mobileBreakpoint.matches) {
          description.classList.remove('collection__description--collapsed');
          description.style.maxHeight = '';
          toggle.hidden = true;
          toggle.textContent = 'Read more';
          toggle.setAttribute('aria-expanded', 'false');
          return;
        }

        description.classList.add('collection__description--collapsed');
        description.style.maxHeight = `${collapsedHeight}px`;
        toggle.textContent = 'Read more';
        toggle.setAttribute('aria-expanded', 'false');

        const currentMaxHeight = description.style.maxHeight;
        description.style.maxHeight = 'none';
        const expandedHeight = description.scrollHeight;
        description.style.maxHeight = currentMaxHeight;

        toggle.hidden = expandedHeight <= collapsedHeight + 1;
      };

      toggle.addEventListener('click', () => {
        const isCollapsed = description.classList.toggle('collection__description--collapsed');
        description.style.maxHeight = isCollapsed ? `${collapsedHeight}px` : 'none';
        toggle.textContent = isCollapsed ? 'Read more' : 'Read less';
        toggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      });

      applyState();
      if (mobileBreakpoint.addEventListener) {
        mobileBreakpoint.addEventListener('change', applyState);
      } else if (mobileBreakpoint.addListener) {
        mobileBreakpoint.addListener(applyState);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initCollectionDescriptionToggle(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target) initCollectionDescriptionToggle(event.target);
  });

  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
